import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TokenStorageService } from './token-storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionValidatorService {
  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}

  validateSession(): void {
    const token = this.tokenStorage.getToken();
    
    if (!token) {
      this.redirectToLogin();
      return;
    }

    this.http.get(`${environment.baseUrl}/church/auth/validate-session`).subscribe(
      () => {
        // Session valid, continue
      },
      (error) => {
        if (error.status === 401) {
          this.clearAndRedirect();
        }
      }
    );
  }

  private clearAndRedirect(): void {
    this.tokenStorage.signOut();
    this.redirectToLogin();
  }

  private redirectToLogin(): void {
    this.router.navigate(['/authentication/signin']);
  }
}
